import { connect, } from 'react-redux';

import { AppState, } from '../../sew-core/types';
import ExpertReviewPanel from '../components/ExpertReviewPanel';
import { onExpertReviewsReadMoreClick, } from '../../sew-core/actions';

const mapStateToProps = (state: AppState,) => ({
  expertReviewAndRating: state.expertReviewAndRating,
});

const mapDispatchToProps = (dispatch,) => ({
  onExpertReviewsReadMoreClick: () => dispatch(onExpertReviewsReadMoreClick(),),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExpertReviewPanel,);
